<template>
  <div class="app-wrap">
    <rc-but-list class="back-but-data" :but-data="backButData"></rc-but-list>
    <rc-edit-dialog
      :data="editData"
      :row="editRow"
      :form-item="editFormItem"
      :img-icon="editImgIcon"
      :title="editTitle"
      :clear-empty-fields="false"
      :api-confirm="editApiConfirm"
      :params-structure="editParamsStructure"
      :api-confirm-call="editApiConfirmCall"
    ></rc-edit-dialog>
    <rc-data-table
      ref="rcTable"
      :columns="columns"
      :but="butData"
      :params-structure="paramsStructure"
      :no-page="true"
      :record-name="recordName"
      :delete-api="deleteApi"
      :show-delete-model="false"
      :api="api"
      :dialog="dialog"
      :table-data-source-list="editTableDataSourceList"
      :table-list="tableList"
      :row-key-to-str="false"
      @selection-change="selectionChange"
    >
      <template #orgName="{ row }">
        <span>{{row.orgName}}</span>
        <span :class="`org-level org-level-${row.orgLevel}`">{{orgLevelList[row.orgLevel]}}</span>
      </template>
    </rc-data-table>
  </div>
</template>

<script>
import orgNew from "@/api/org/orgNew";
import { createObject } from "@/utils";
export default {
  name: "OrgGroup",
  data() {
    return {
      deleteApi: {
        model: orgNew,
        name: "editOrg"
      },
      orgLevelList: {
        1: "主组织",
        2: "子组织"
      },
      recordName: "organizations",
      columns: [{
        label: "组织名称",
        prop: "orgName",
        customer: true
      }, {
        label: "管理员",
        prop: "displayName"
      }, {
        label: "手机号",
        prop: "cellphone"
      }, {
        label: "操作",
        prop: "button",
        type: "button",
        width: 60,
        button: {
          butData: [{
            prop: "delete",
            type: "text",
            label: "删除"
          }]
        }
      }],
      api: {
        model: orgNew,
        name: "groupId"
      },
      butData: {
        butData: [{
          label: "添加组织",
          prop: "add",
          type: "primary"
        }],
        bottom16: true
      },
      form: {
        inline: true,
        closeLayout: true
      },
      formData: {
        search: ""
      },
      formItem: [{
        component: "rc-search",
        prop: "search",
        placeholder: "请输入组织名称",
        span: 8
      }],
      dialog: {
        contentType: "data-table",
        delete: {
          showDelete: false
        },
        replaceFields: {
          pageNum: "page",
          pageSize: "size"
        },
        width: "800px",
        imgIcon: "success",
        title: "添加组织",
        padding24: false,
        disabled: this.disabledFn,
        api: {
          model: orgNew,
          name: "all"
        },
        apiConfirm: {
          model: orgNew,
          name: "editOrg"
        },
        paramsStructure: this.confirmParamsStructure,
        tableList: this.tableList,
        columns: [{
          prop: "selection",
          type: "selection"
        }, {
          label: "组织名称",
          prop: "orgName"
        }, {
          label: "管理员",
          prop: "displayName"
        }, {
          label: "手机号",
          prop: "cellphone"
        }],
        form: {
          data: {
            search: ""
          },
          formItem: [{
            component: "rc-search",
            prop: "search",
            placeholder: "请输入组织名称",
            span: 8
          }]
        }
      },
      selection: [],
      backButData: [{
        label: "组织群详情",
        type: "text",
        icon: "el-icon-back",
        prop: "router",
        name: "orgGroup"
      }],
      queryId: "",
      editTitle: "修改基本信息",
      editImgIcon: "success",
      editData: {
        orgGroupName: "",
        description: ""
      },
      editFormItem: [{
        component: "rc-input",
        label: "组织群名称",
        placeholder: "请输入组织群名称",
        prop: "orgGroupName",
        span: 24,
        aliasLabel: "名称",
        rules: [
          { required: true, message: "请输入组织群名称", trigger: ["change", "blur"] },
          {
            type: "string",
            required: true,
            pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,}$/,
            message: "不能输入空格，长度至少2位且不能含特殊字符"
          }
        ]
      }, {
        component: "rc-input",
        label: "描述",
        placeholder: "请输入内容",
        prop: "description",
        type: "textarea",
        autosize: {
          minRows: 3, maxRows: 3
        },
        slotStyle: {
          marginLeft: "8px",
          fontSize: "12px",
          color: "rgb(158, 165, 178)",
          fontWeight: "normal"
        },
        slotLabel: "选填",
        span: 24
      }],
      editRow: {},
      editApiConfirm: {
        model: orgNew,
        name: "editOrg"
      }
    };
  },
  computed: {
    table() {
      return this.$refs.rcTable;
    }
  },
  methods: {
    disabledFn(but) {
      return but.prop === "confirm" && !this.selection.length;
    },
    selectionChange(selection) {
      this.selection = selection;
    },
    paramsStructure(params, name, { keys }) {
      this.queryId = this.$route.query.id;
      if (name === "table") { return this.queryId; }
      if (name === "delete") {
        return {
          id: this.queryId,
          orgGroup: keys.filter(item => item !== params[0])
        };
      }
    },
    confirmParamsStructure(params, other) {
      const old = this.editRow && this.editRow[this.recordName] || [];
      return {
        id: this.queryId,
        orgGroup: this.filter([...old, ...other])
      };
    },
    filter(data) {
      if (!data) { return []; };
      return data && data.map(item => item.id);
    },
    editTableDataSourceList(data) {
      this.editRow = data || {};
    },
    editParamsStructure(params, { data }) {
      return {
        id: this.queryId,
        ...data || {}
      };
    },
    editApiConfirmCall() {
      this.table.refresh();
    },
    tableList(obj) {
      return { ...obj, table: this.withUser(obj.table) };
    },
    withUser(data) {
      if (!data) { return data; };
      return data.map(item => createObject({ target: item, source: item.user || {}, filter: ["displayName", "cellphone"] }));
    }
  }
};
</script>

<style lang="scss" scoped>
.back-but-data {
  padding: 0 24px;
  box-shadow: 0 2px 4px 0 rgb(33 37 46 / 12%);
  border-bottom: 1px solid #e8e8e8;
  height: 48px;
  line-height: 48px;
  ::v-deep span {
    color: $scim-text-color;
  }
}
.org-level {
  padding: 0 8px;
  margin-left: 8px;
  font-size: 12px;
  line-height: 20px;
  display: inline-block;
}
.org-level-1 {
  color: #00B259;
  background: #f6ffed;
  border-color: #f6ffed;
}
.el-table__body tr:hover .org-level-2 {
  background: #fafafa;
  border-color: #fafafa;
}
</style>
